import { Pipe, PipeTransform } from '@angular/core';
import { DprCard } from '@dpr/models';

@Pipe({ name: 'uploadSignedReportTooltip' })
export class UploadSignedReportTooltipPipe implements PipeTransform {
  transform(data: DprCard, isAppOnline: boolean, canEdit: boolean): string {
    if (
      !data.dprDetailLockedDate &&
      this.canLockDpr(data, isAppOnline, canEdit)
    ) {
      return $localize`:@@dpr.uploadSignedReportTooltipPipe.attrDprNeedsToBeLocked:The DPR needs to be locked before uploading`;
    }
    if (data.hasActiveSignRequest && !data.isSignDprDetailsUploaded) {
      return $localize`:@@dpr.uploadSignedReportTooltipPipe.attrDprHasActiveESignRequest:The DPR has an active e-sign request`;
    }
    if (data.dprDetailsFirstWarning != null) {
      return $localize`:@@dpr.uploadSignedReportTooltipPipe.attrDprIsIncomplete:The DPR is incomplete`;
    }
    return null;
  }

  private canLockDpr(
    data: DprCard,
    isAppOnline: boolean,
    canEdit: boolean
  ): boolean {
    return (
      data && data.dprDetailsFirstWarning == null && canEdit && isAppOnline
    );
  }
}
